import { SIZES } from "../constants/sizes";

export const TYPOGRAPHY = {
  H1: {
    fontSize: SIZES.H1,
    fontWeight: 600,
    lineHeight: "40px",
  },
  H2: {
    fontSize: SIZES.H2,
    fontWeight: 600,
    lineHeight: "36px",
  },
  H3: {
    fontSize: SIZES.H3,
    fontWeight: 600,
    lineHeight: "28px",
  },
  H4: {
    fontSize: SIZES.H4,
    fontWeight: 600,
    lineHeight: "20px",
  },
  bodyLg: {
    fontSize: SIZES.bodyLg,
    fontWeight: 400,
    lineHeight: "28px",
  },
  bodyMd: {
    fontSize: SIZES.bodyMd,
    fontWeight: 400,
    lineHeight: "24px",
  },
  bodySm: {
    fontSize: SIZES.bodySm,
    fontWeight: 400,
    lineHeight: "20px",
  },
};
